const apiCache = new Map<string, { data: any; expiry: number }>()

export const cachedApiCall = async <T>(
  key: string,
  apiCall: () => Promise<T>,
  ttl: number = 5 * 60 * 1000
): Promise<T> => {
  const now = Date.now()
  const cached = apiCache.get(key)

  if (cached && cached.expiry > now) {
    return cached.data
  }

  const result = await apiCall()
  apiCache.set(key, { data: result, expiry: now + ttl })

  return result
}
